module.exports = __webpack_public_path__ + "img/worm-folded.5507b333.png";